const initState = {
    operationIsSuccess: null,
    waitingMode: null
}

const appReducer = (state=initState, action) =>{
    switch (action.type){
        default:
            return state
    }
    
}

export default appReducer